module.exports = __webpack_public_path__ + "static/media/switch-dark.54599ad9.svg";